module.exports = true;



//////////////////
// WEBPACK FOOTER
// ../core-js/library/modules/_library.js
// module id = 236
// module chunks = 22